/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */
import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
import {CustomEase} from 'gsap/CustomEase';
( function( app ) {
  const COMPONENT = {
    init: function() {
      gsap.registerPlugin( ScrollTrigger );
      gsap.registerPlugin( CustomEase );

      // ANIMATIONS FOR POST CARDS
      gsap.to( '.content.red-cover-animation', {
        scrollTrigger: {
          trigger: '.content.red-cover-animation',
          start: 'top 85%',
        },
        ease: CustomEase.create( 'custom', 'M0,0 C0.428,0 0.426,0.181 0.5,0.47 0.572,0.752 0.528,0.99 1,1 ' ),
        duration: .025,
        y: 230,
        backgroundColor: '#DA272D',
      } );

      gsap.to( '.short-posts.red-cover-animation', {
        scrollTrigger: {
          trigger: '.short-posts.red-cover-animation',
          start: 'top 85%',
        },
        ease: CustomEase.create( 'custom', 'M0,0 C0.428,0 0.426,0.181 0.5,0.47 0.572,0.752 0.528,0.99 1,1 ' ),
        duration: .025,
        y: 230,
        backgroundColor: '#DA272D',
      } );

      gsap.to( '.tall-post.red-cover-animation', {
        scrollTrigger: {
          trigger: '.tall-post.red-cover-animation',
          start: 'top 85%',
        },
        ease: CustomEase.create( 'custom', 'M0,0 C0.428,0 0.426,0.181 0.5,0.47 0.572,0.752 0.528,0.99 1,1 ' ),
        duration: .025,
        y: 546,
        backgroundColor: '#DA272D',
      } );

      gsap.to( '.news.red-cover-animation', {
        scrollTrigger: {
          trigger: '.news.red-cover-animation',
          start: 'top 85%',
        },
        ease: CustomEase.create( 'custom', 'M0,0 C0.428,0 0.426,0.181 0.5,0.47 0.572,0.752 0.528,0.99 1,1 ' ),
        duration: .025,
        y: 230,
        backgroundColor: '#DA272D',
      } );

      gsap.to( '.featured.red-cover-animation', {
        scrollTrigger: {
          trigger: '.featured.red-cover-animation',
          start: 'top bottom',
        },
        ease: CustomEase.create( 'custom', 'M0,0 C0.428,0 0.426,0.181 0.5,0.47 0.572,0.752 0.528,0.99 1,1 ' ),
        duration: .025,
        y: 378,
        backgroundColor: '#DA272D',
      } );

      $( '.navbar-toggle' ).on( 'toggleAfter', ( event ) => {
        $( '.primary-nav' ).slideToggle();
      } );

      // TEMPLATE TABBED PAGE

      const tabName = document.querySelectorAll( '[data-tab-name]' );
      const allContent = document.querySelectorAll( '.changing-content' );

      tabName.forEach( ( tn, idx ) => {
        tn.addEventListener( 'click', () => {
          allContent.forEach( ( tab ) => {
            tab.classList.remove( 'active-tab' );
          } );
          tabName.forEach( ( tName ) => {
            tName.classList.remove( 'active-nav' );
          } );
          tabName[idx].classList.add( 'active-nav' );
          const tab = tn.getAttribute( 'data-tab-name' );
          const changingContent = document.getElementById( tab );
          changingContent.classList.add( 'active-tab' );
        } );
      } );

      $( '.js-init-video' ).magnificPopup( {
        type: 'iframe',
        mainClass: 'mfp-fade',
        removalDelay: 160,
        preloader: false,
        fixedContentPos: false,
        callbacks: {
          open: function() {
            $( 'video' ).trigger( 'pause' );
          },
          close: function() {
            $( 'video' ).trigger( 'play' );
          },
        },
      } );
      // NAVIGATION GOODNESS
      $( document ).on( 'click', function() {
        if ( document.activeElement.classList.contains( 'main-menu-title' ) && ( document.activeElement.classList.contains( 'is-open' ) || document.activeElement.classList.contains( 'active' ) ) ) {
          $( 'body' ).addClass( 'no-scroll body-overlay' );
        } else {
          $( 'body' ).removeClass( 'no-scroll body-overlay' );
        }
      } );

      // ANNOUNCEMENT BANNER
      if ( sessionStorage.getItem( 'bannerSeen' )!='true' ) {
        setTimeout( function() {
          $( '.announcement-banner' ).addClass( 'open' );
          sessionStorage.setItem( 'bannerSeen', 'true' );
        }, 500 );
      }
      $( '.announcement-banner .exit' ).on( 'click', function() {
        $( '.announcement-banner' ).removeClass( 'open' );
      } );
      // HEADER SEARCH BUTTON
      $( '.search-button' ).on( 'click', function() {
        $( 'html' ).addClass( 'searchActivated no-scroll' );
        $( 'input.hhi-search' ).focus();
      } );
      $( '.search-popup__icon-wrapper' ).on( 'click', function() {
        $( 'html' ).removeClass( 'searchActivated no-scroll' );
      } );
      // FOR FORMS
      // CHECK IF SELECT SELECTED AND GIVE CLASS
      checkSelectPlaceholder();
      $( '.gfield_select' ).on( 'change', function() {
        checkSelectPlaceholder();
      } );
      function checkSelectPlaceholder() {
        if ( $( '.gfield_select' ).find( 'option:selected' ).hasClass( 'gf_placeholder' ) ) {
          $( '.gfield_select' ).removeClass( 'placeholder-selected' );
        } else {
          $( '.gfield_select' ).addClass( 'placeholder-selected' );
        }
      }
      // FILE UPLOAD STYLING
      if ( $( '.gform_wrapper' ).length > 0 && typeof( gform ) !== 'undefined' ) {
        gform.addAction( 'gform_input_change', function( elem, formId, fieldId ) {
          if ( $( '#input_' + formId + '_' + fieldId ).val() ) {
            const path = $( '#input_' + formId + '_' + fieldId ).val().replace( 'C:\\fakepath\\', '' );
            $( '#input_' + formId + '_' + fieldId ).closest( '.ginput_container_fileupload' ).find( '.file-upload-label' ).text( path );
            $( '#input_' + formId + '_' + fieldId ).closest( '.ginput_container_fileupload' ).addClass( 'has-file' );
          } else {
            $( '#input_' + formId + '_' + fieldId ).closest( '.ginput_container_fileupload' ).find( '.file-upload-label' ).text( 'No file selected' );
            $( '#input_' + formId + '_' + fieldId ).closest( '.ginput_container_fileupload' ).removeClass( 'has-file' );
          }
        }, 10, 3 );
      }

      // MULTI PAGE QUOTER
      $( '#btn--start-form' ).on( 'click', function() {
        $( '.mpq-intro-page' ).css( 'opacity', '0' );
        $( '.mqp-progress-bar' ).css( 'display', 'block' );
        setTimeout( () => {
          $( '.mpq-intro-page' ).removeClass( 'active' );
        }, 700 );
      } );


      // ON PAGE CHANGE
      $( document ).on( 'gform_page_loaded', function( event, formId, currentPage ) {
        const width = $( '.llgq-progress' ).width() / $( '.llgq-progress' ).parent().width() * 100;
        const widthPercentage = Math.round( width );
        $( '.llgq-current-page .progress-percentage' ).text( widthPercentage + '%' );

        $( '.mpf-skip-btn' ).on( 'click', function() {
          if ( $( '.llgq-current-page .gform_page_footer input[type="submit"]' ).length ) {
            $( '.llgq-current-page .gform_page_footer input[type="submit"]' ).trigger( 'click' );
          } else {
            $( '.llgq-current-page .gform_next_button' ).trigger( 'click' );
          }
        } );
      } );

      $( document ).on( 'updateMediaQuery', ( event ) => {
        /*
         * Remove any inline display values when the screen changes
         * between mobile and desktop state. This allows the default
         * stylings to kick in and prevent any weird "half mobile half desktop"
         * nav display states that sometimes occur while resizing the browser
         * Also remove any active is-open classes from the toggle and nav to reset
         * its state when switching between screen sizes
         */
        $( '.primary-nav' ).get( 0 ).style.removeProperty( 'display' );
        $( '.navbar-toggle, .primary-nav' ).removeClass( 'is-open' );
      } );
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'common', COMPONENT );
} )( app );
